import { render, staticRenderFns } from "./realtest_paper.vue?vue&type=template&id=bf897a7c&scoped=true"
import script from "./realtest_paper.vue?vue&type=script&lang=js"
export * from "./realtest_paper.vue?vue&type=script&lang=js"
import style0 from "./realtest_paper.vue?vue&type=style&index=0&id=bf897a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf897a7c",
  null
  
)

export default component.exports